import {Alert, DataStatus} from 'platform/components';
import {Heading, Show, Space, Text} from 'platform/foundation';

import {Trans} from 'react-i18next';

import {isNotNil} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';

interface WelcomeSidebarProps extends TestIdProps {
  requestId?: string;
  count: number | null;
  isCountLoading: boolean;
}

export function WelcomeSidebar(props: WelcomeSidebarProps) {
  return (
    <>
      <Heading size={3}>{i18n.t('page.create.labels.welcomeToPriceReport')}</Heading>
      <Space vertical={6} />
      <Text size="small">
        <Trans
          i18nKey="page.create.labels.about1Paragraph"
          components={{
            bold: <Text key="bold" size="small" alternative inline />,
          }}
        />
      </Text>
      <Space vertical={4} />
      <Show when={isNotNil(props.count)}>
        <Text size="small">{i18n.t('page.create.labels.about2Paragraph')}</Text>
        <Space vertical={6} />
        <DataStatus isLoading={props.isCountLoading} minHeight={15}>
          <Show when={isNotNil(props.count) && props.count > 0}>
            <Alert
              type="inline"
              variant="info"
              title={i18n.t('page.create.labels.similarVehicles', {
                soldCount: String(props.count),
              })}
              data-testid={suffixTestId('similarVehicles', props)}
            />
          </Show>
          <Show when={props.count === 0}>
            <Alert
              type="inline"
              variant="warning"
              title={i18n.t('page.create.labels.vehicleNotFound')}
              data-testid={suffixTestId('noVehicleFound', props)}
            />
          </Show>
        </DataStatus>
      </Show>
    </>
  );
}
